var _defs, _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.05 158.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00be40;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 158.05,
    height: 158.05,
    rx: 15.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.39,
    y: 100.03,
    width: 95.56,
    height: 7.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.47,62.14V54.41H31.39V90.49h9.53V77.66H55.66V69.92H40.92V62.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86,71.78c3.81-1.76,5.82-4.54,5.82-8,0-5.83-4.32-9.33-11.6-9.33H61.76V90.49H80.42c7.94,0,12.68-3.76,12.68-10.15C93.1,76.21,90.47,73.12,86,71.78ZM71.09,61.73h7.37c2.68,0,4.12,1.23,4.12,3.51s-1.44,3.5-4.12,3.5H71.09Zm8,21.44h-8V76h8.09c2.68,0,4.18,1.28,4.18,3.71C83.36,82,81.86,83.17,79.08,83.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.1,68.58,111.76,68c-4.28-.62-5.54-1.67-5.54-3.66s1.67-3.35,5.39-3.35c3.44,0,5.13,1.27,5.94,4.41l9.07-1.17c-1.33-7.1-6.43-10.55-14.75-10.55-9.31,0-15.43,4.65-15.43,11.76,0,6.11,3.71,9.67,11.3,10.72l4.54.62c4.81.69,6,1.78,6,3.88s-1.78,3.35-6,3.35a6.83,6.83,0,0,1-6.84-4.81l-9.45,1.42c1.53,7.35,7.12,10.7,16,10.7,10.09,0,16.05-4.34,16.05-11.71C128,73.13,124.36,69.78,116.1,68.58Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbs);
export default __webpack_public_path__ + "static/media/fbs.0fb9f1451dafc8ad52553ee2b3d10eb1.svg";
export { ForwardRef as ReactComponent };